module.exports = __webpack_public_path__ + "img/logoFta.a4b0918b.png";